import React, { useEffect, useRef, useState } from 'react';
import sharedStyles from '../styles/kclatestupdates.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from './CustomImage';
import Card from 'react-bootstrap/Card';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import fetchUtil from '../utils/fetchUtil';
import router from 'next/router';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import LazyReveal from './LazyReveal';
import layoutSnapshot from '../lib/layout-snapshot.json';
import type { LayoutSnapshot } from '../lib/types/layout-snapshot';

const snapshot = layoutSnapshot as LayoutSnapshot;

const KcNewLatestUpdates: React.FC = (incomingProps: any) => {
  const props = { ...incomingProps, footerData: incomingProps?.footerData ?? snapshot.footerData };
  const sliderRef = useRef<Slider>(null);
  const [news, setNews] = useState<any>([]);
  const settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
  };

  const desktopSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },

    ]
  };
  useEffect(() => {
    fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?stu_dest_categories.category=News&_sort=date:DESC`,
      'GET',
      {},
      '',
      false
    ).then((res: any) => {
      setNews(res);
    });
  }, []);
  return (
    <LazyReveal id='kcupdates-main-div' className={sharedStyles.kcupdatesMainDiv}>
      <Container>
        <Row>
          <div>
            <h2 className='text-center'>Latest KC Updates</h2>
          </div>
        </Row>
        {/* desktop view */}
        <div className='d-none d-sm-block'>
          <div id='kcupdates-div' className={sharedStyles.kcupdatesDiv}>
            <Row>
              <Col lg={5} md={4} sm={4}>
                <Card
                  className={`${sharedStyles.card} ${sharedStyles.weHireCard}`}
                >
                  <Card.Body className={sharedStyles.cardBody}>
                    <Card.Title className={sharedStyles.title}>
                      {props.footerData?.hiringTitle}
                    </Card.Title>
                    <Card.Text className={sharedStyles.text}>
                      {props.footerData?.hiringDescription}
                    </Card.Text>
                    <a
                      href={props.footerData?.hiringButtonLink}
                      className={sharedStyles.navLink}
                      aria-label={props.footerData?.hiringButtonLabel}
                    >
                      {props.footerData?.hiringButtonLabel}
                    </a>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={7} md={8} sm={8}>
                <Row>
                  <Slider {...desktopSettings}>
                    {news.length > 0 &&
                      news.map((data: any, index: number) => {
                        return (
                          <Col key={index} lg={6} md={6} sm={6}>
                            <div>
                              <a
                                href={
                                  data?.isExternalLink && data?.externalLink
                                    ? data?.externalLink
                                    : `/news/${data.slug}`
                                }
                                aria-label="Read more"
                              >
                                <Card
                                  className={`${sharedStyles.card} ${sharedStyles.certificate}`}
                                >
                                  <Card.Body className={sharedStyles.cardBody}>
                                    <LazyLoadComponent>
                                      <div className={sharedStyles.img}>
                                        <Card.Img
                                          height={120}
                                          width={120}
                                          variant='top'
                                          alt={data?.newCardImageUrl?.alt}
                                          src={
                                            data?.newCardImageUrl?.imageUrl ||
                                            '/recognitions/airc.svg'
                                          }
                                        />
                                      </div>
                                    </LazyLoadComponent>
                                    <div className={sharedStyles.titleClass}>
                                      {data?.title}
                                    </div>
                                    <p className={sharedStyles.description}>
                                      {data?.shortDescription}
                                    </p>
                                    <div className={sharedStyles.star}>
                                      <CustomImage
                                        src='/recognitions/stars.svg'
                                        alt='multi-country.svg'
                                        width={70}
                                        height={20}
                                      />
                                    </div>
                                    <a className={sharedStyles.readMore} href={
                                      data?.isExternalLink && data?.externalLink
                                        ? data?.externalLink
                                        : `/news/${data.slug}`
                                    } aria-label="Read more">
                                      Read More
                                    </a>
                                  </Card.Body>
                                </Card>
                              </a>
                            </div>
                          </Col>
                        );
                      })}
                  </Slider>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
        {/* mobile view */}
        <div className='d-block d-sm-none'>
          <div id='kcupdates-divs' className={sharedStyles.kcupdatesDiv}>
            <Slider {...settings} ref={sliderRef} className={sharedStyles.slider}>
              <div>
                <Card
                  className={`${sharedStyles.card} ${sharedStyles.weHireCard}`}
                >
                  <Card.Body className={sharedStyles.cardBody}>
                    <Card.Title className={sharedStyles.title}>
                      {props.footerData?.hiringTitle}
                    </Card.Title>
                    <Card.Text className={sharedStyles.text}>
                      {props.footerData?.hiringDescription}
                    </Card.Text>
                    <a
                      href={props.footerData?.hiringButtonLink}
                      className={sharedStyles.navLink}
                    >
                      {props.footerData?.hiringButtonLabel}
                    </a>
                  </Card.Body>
                </Card>
              </div>
              {news.length > 0 &&
                news.map((data: any, index: number) => {
                  return (
                    <div key={index}>
                      <a
                        href={
                          data?.isExternalLink && data?.externalLink
                            ? data?.externalLink
                            : `/news/${data.slug}`
                        }
                        aria-label={`Read more about ${data.title}`}
                      >
                        <Card
                          className={`${sharedStyles.card} ${sharedStyles.certificate}`}
                          key={index}
                          onClick={() => router.push(`/news/${data.slug}`)}
                        >
                          <Card.Body className={sharedStyles.cardBody}>
                            <LazyLoadComponent>
                              <div className={sharedStyles.img}>
                                <Card.Img
                                  variant='top'
                                  src={
                                    data?.cardImageUrl ||
                                    '/recognitions/airc.svg'
                                  }
                                />
                              </div>
                            </LazyLoadComponent>
                            <div className={sharedStyles.titleClass}>
                              {data?.title}
                            </div>
                            <p className={sharedStyles.description}>
                              {data?.shortDescription}
                            </p>
                            <div className={sharedStyles.star}>
                              <CustomImage
                                src='/recognitions/stars.svg'
                                alt='multi-country.svg'
                                width={70}
                                height={20}
                              />
                            </div>
                            <a className={sharedStyles.readMore} href={`/news/${data.slug}`} aria-label={`Read more about ${data.title}` } >Read More</a>
                          </Card.Body>
                        </Card>
                      </a>
                    </div>
                  );
                })}
            </Slider>
            <div className={sharedStyles.arrowsClass}>
              <div
                className={sharedStyles.btcircle}
                onClick={() => sliderRef?.current?.slickPrev()}
              >
                <CustomImage
                  src="/new-images/left-arrow.svg"
                  height={17}
                  width={10}
                  alt={"arrowleft"}
                />

              </div>
              <div
                className={sharedStyles.btcircle}
                onClick={() => sliderRef?.current?.slickNext()}
              >
                <CustomImage
                  src="/new-images/right-arrow.svg"
                  height={17}
                  width={10}
                  alt={"arrowright"}
                />
              </div>
            </div>
          </div>
        </div>
        <Row className='text-center'>
          <div className='mt-4 mb-3'>
            <a
              id='kcupdate-news'
              href='/news'
              className={sharedStyles.viewMore}
            >
              More News
            </a>
          </div>
        </Row>
      </Container>
    </LazyReveal>
  );
};
export default KcNewLatestUpdates;
